import { type List as ImmutableList, Record, type RecordOf } from 'immutable';

import type { ReportStoreProps } from '../core/reportStoreTypes';

export const ACCOUNTS_VALUE_CHANGES_REDUCER_KEY = 'accountsValueChangesStore';
export type ACCOUNTS_VALUE_CHANGES_REDUCER_KEY = typeof ACCOUNTS_VALUE_CHANGES_REDUCER_KEY;

export type AccountsValueChangesColumn = {
  field?: string;
  headerName?: string;
  id?: number;
};

export type AccountsValueChangesCell = {
  columnId?: number;
  date?: string | null;
  fieldName?: string | null;
  headerName?: string;
  id?: number;
  isEstimated?: boolean;
  value?: number | null;
};

export type AccountsValueChangesRow = {
  cellData?: AccountsValueChangesCell[];
  colorIndex?: number;
  date?: string | null;
  entityId?: number | string;
  id?: number;
  name?: string;
};

export type AccountsValueChangesPageProps = {
  clientId?: string | null;
  columns?: AccountsValueChangesColumn[];
  id?: string | null;
  isDeleted?: boolean | null;
  rowType?: string;
  rows?: AccountsValueChangesRow[];
};

export type AccountsValueChangesPage = RecordOf<AccountsValueChangesPageProps>;

type AccountsValueChangesPageInput = Partial<AccountsValueChangesPageProps> & {
  toJS?: () => AccountsValueChangesPageProps;
};

const AccountsValueChangesRecord = Record<AccountsValueChangesPageProps>({
  columns: undefined,
  rowType: undefined,
  rows: undefined,
});

export const mkAccountsValueChanges = (props?: AccountsValueChangesPageInput | null): AccountsValueChangesPage => {
  const pageProps = props?.toJS ? props.toJS() : props;
  return AccountsValueChangesRecord(pageProps ?? undefined);
};

export type AccountsValueChangesRowList = ImmutableList<AccountsValueChangesRow>;
export type AccountsValueChangesColumnCollection =
  | AccountsValueChangesColumn[]
  | ImmutableList<AccountsValueChangesColumn>;

export type AccountsValueChangesStoreProps = Omit<ReportStoreProps, 'columns' | 'error' | 'rows'> & {
  columns?: AccountsValueChangesColumnCollection;
  error?: unknown;
  rows?: AccountsValueChangesRowList;
};

export type AccountsValueChangesStore = RecordOf<AccountsValueChangesStoreProps>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ACCOUNTS_VALUE_CHANGES_REDUCER_KEY]: AccountsValueChangesStore;
  }
}
